import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { DocumentTemplatesDataGrid } from "src/components/views/documents/documentTemplate/DocumentTemplatesDataGrid.tsx";

export const Route = createFileRoute("/_authenticated/_shell/common/documentTemplates")({
	staticData: { title: i18n.t("document_templates"), legacyViewKey: "documentTemplatesPage" },
	component: RouteComponent,
});

function RouteComponent() {
	return <DocumentTemplatesDataGrid />;
}
